import { render, staticRenderFns } from "./accountTemplateManage.vue?vue&type=template&id=31e5bc76&scoped=true"
import script from "./accountTemplateManage.vue?vue&type=script&lang=js"
export * from "./accountTemplateManage.vue?vue&type=script&lang=js"
import style0 from "./accountTemplateManage.vue?vue&type=style&index=0&id=31e5bc76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e5bc76",
  null
  
)

export default component.exports